<template lang="pug">
#CambiarAFacturaPagoFinal
  b-button(
    variant="action"
    @click="openModal"
    :disabled="disabled"
  )
    | Cambiar a Factura Pago Final
  ModalCambiarBoletaAFactura(
    :showModal="showModal"
    :pago="pagoPagoFinal"
    :ov="dataOv"
    @close="showModal = false"
    @cambiado="onCambiado"
  )
</template>

<script>
import ModalCambiarBoletaAFactura from '../../ModalCambiarBoletaAFactura.vue'

export default {
  name: 'CambiarAFacturaPagoFinal',
  components: {
    ModalCambiarBoletaAFactura,
  },
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    pagoPagoFinal() {
      const docs = this.dataOv?.documentos_pago || []
      // El elegible según el back (puede haber un pago anterior ya cambiado)
      const found =
        docs.find(
          (p) => p.tipo_pago === 'PAGO_TOTAL' && p.puede_cambiar_a_factura
        ) || docs.find((p) => p.tipo_pago === 'PAGO_TOTAL')
      if (found) return found

      return {
        id: null,
        tipo_pago: 'PAGO_TOTAL',
        tipo_documento: 'boleta',
        numero_documento: this.dataOv?.nro_boleta_pago,
        monto: this.dataOv?.monto_total_final,
        created_at: this.dataOv?.created_at,
      }
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    onCambiado() {
      this.showModal = false
      this.$emit('reloadAll')
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('../Styles/Index.scss');

#CambiarAFacturaPagoFinal {
  width: 100%;
  text-align: center;

  ::v-deep .btn {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}
</style>
